
import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';
import './WorkWith.css';

const WorkWith = () => {
    const [ref, isVisible] = useIntersectionObserver();

    return (
        <section className="work-with-section section" ref={ref}>
            <div className="container">
                <div className="work-with-layout">
                    {/* Left Column - Why Triology */}
                    <motion.div
                        className="work-with-col"
                        initial={{ opacity: 0, x: -50 }}
                        animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h3 className="work-with-title">Why Triology</h3>
                        <p className="work-with-intro">Clients choose Triology because we bring:</p>

                        <div className="work-with-list-wrapper">
                            <ul className="work-with-list">
                                <li>
                                    <span className="bullet-point"></span>
                                    Diagnosis before solutions
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    Structure before acceleration
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    Execution governance, not just advice
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    Deep involvement, not arm’s-length consulting
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    Balance of conscious leadership and operational rigor
                                </li>
                            </ul>
                        </div>

                        <p className="work-with-desc">
                            We partner closely with leadership teams to ensure change is embedded not outsourced.
                        </p>
                    </motion.div>

                    {/* Right Column - Who We Work With */}
                    <motion.div
                        className="work-with-col"
                        initial={{ opacity: 0, x: 50 }}
                        animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <h3 className="work-with-title">Who We Work With</h3>
                        <p className="work-with-intro">We work best with organizations that:</p>

                        <div className="work-with-list-wrapper">
                            <ul className="work-with-list">
                                <li>
                                    <span className="bullet-point"></span>
                                    are in a growth or transition phase
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    value clarity over quick fixes
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    are willing to examine systems and leadership alignment
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    want execution discipline, not just recommendations
                                </li>
                            </ul>
                        </div>

                        <div className="work-with-footer-right">
                            <p>Triology may not be the right fit for organizations seeking short-term fixes or ready-made answers.</p>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default WorkWith;
